<main class="px-md-0 banner">
  <!-- Page content goes here -->
  <div class="">
    <div id="myCarousel" class="carousel slide" data-bs-ride="carousel">
      <!-- 
      <ol class="carousel-indicators">
        <li data-bs-target="#myCarousel" data-bs-slide-to="0" class="active"></li>
        <li data-bs-target="#myCarousel" data-bs-slide-to="1"></li>
        <li data-bs-target="#myCarousel" data-bs-slide-to="2"></li>
      </ol>-->
      <!-- Slides -->
      <div class="carousel-inner">
        <!-- <div class="carousel-item active">
          <img src="/assets/website-assets/images/banner_img4.jpg" class="img-fluid w-100" alt="Image 1">
          
        </div>
        <div class="carousel-item">
          <img src="/assets/website-assets/images/banner_img1.jpg" class="img-fluid w-100" alt="Image 2">
         
        </div>
        <div class="carousel-item">
          <img src="/assets/website-assets/images/banner_img2.jpg" class="img-fluid w-100" alt="Image 3">
          
        </div>  -->
        <div *ngFor="let item of arr_banner; let i = index" class="carousel-item" [class.active]="i === 0">
          <img class="img-fluid w-100" [src]="item.FilePath" alt="Banner Image">
        </div>

        <!-- <div class="carousel-caption" style="display: inline-flex;">
            <p style="margin-left: 30px;
            margin-right: 30px"> ॐ सिद्धाय नमः ॐ सिद्धाय नमः ॐ सिद्धाय नमः ॐ सिद्धाय नमः ॐ सिद्धाय नमः 
           </p>
           <p style="margin-left: 30px;
           margin-right: 30px">  ॐ ॐ ॐ सिद्धाय नमः ॐ सिद्धाय नमः ॐ सिद्धाय नमः ॐ सिद्धाय नमः 
          </p>
          <p style="margin-left: 30px;
          margin-right: 30px">  ॐ ॐ ॐ 
         </p>
          </div> -->
        <div class="carousel-caption" style="display: inline-flex;">
          <p style="margin-left: 30px;
            margin-right: 30px" *ngFor="let item of arr_banner">{{item.Content}}
          </p>
        </div>


      </div>
      <!-- Controls -->
      <a class="carousel-control-prev" href="#myCarousel" role="button" data-bs-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="visually-hidden"></span>
      </a>
      <a class="carousel-control-next" href="#myCarousel" role="button" data-bs-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="visually-hidden"></span>
      </a>
    </div>
    <div class="social-banner">
      <ul>
        <li><a href="https://www.facebook.com/profile.php?id=100089367168894" target="_blank"><img
              src="/assets/website-assets/images/facebook.png" alt="Facebook"></a></li>
        <li><a href="https://www.instagram.com/official_baba_balak_nathji610?igsh=c3N2M2Fib3YwdnVp" target="_blank"><img
              src="/assets/website-assets/images/Instagram.png" alt="Instagram"></a></li>
        <li><a href="https://www.youtube.com/@bababalaknathdeotsidhoffic333" target="_blank"><img
              src="/assets/website-assets/images/you_tube.png" alt="YouTube"></a></li>
      </ul>
    </div>
  </div>
</main>
